'use client';

import { createPortal } from 'react-dom';
import { DynamicTable, type DynamicTableRow } from '../DynamicTable/DynamicTable';
import { Text } from '@/ui-components/atoms/Text/Text';
import { CloseIcon } from '@/assets/icons/CloseIcon';
import { DeviceCar } from '@/assets/icons/DeviceCar';
import { DeviceMultiple } from '@/assets/icons/DeviceMultiple';
import styles from './morewaystolisten.module.scss';

export type MoreWaysVariant = 'sports-strip' | 'game-card';

export interface MoreWaysToListenProps {
    rows: DynamicTableRow[];
    variant: MoreWaysVariant;
    popoverHeader?: string;
    popoverCloseAriaLabel?: string;
    onPopoverClose?: () => void;
    popoverClassName?: string;
    renderAs?: 'desktop' | 'mobile';
    desktopRef?: React.RefObject<HTMLDivElement | null>;
    desktopClassName?: string;
    mobileTitle?: string;
    onMobileClose?: () => void;
}

export function MoreWaysToListen({
    rows,
    variant,
    popoverClassName,
    renderAs = 'desktop',
    desktopRef,
    desktopClassName,
    mobileTitle = 'Ways to Listen',
    onMobileClose,
}: MoreWaysToListenProps): React.JSX.Element {
    if (variant === 'sports-strip') {
        return (
            <div className={popoverClassName}>
                <DynamicTable
                    columnLabels={[
                        <DeviceCar key={0} className={styles.overlayIcon} aria-label="In the car" />,
                        <DeviceMultiple key={1} className={styles.overlayIcon} aria-label="On your device" />,
                    ]}
                    rows={rows}
                    className={styles.resetTop}
                />
            </div>
        );
    }

    if (renderAs === 'desktop') {
        return (
            <div ref={desktopRef} className={desktopClassName}>
                <DynamicTable
                    columnLabels={[
                        <DeviceCar key={0} className={styles.overlayIcon} aria-label="In the car" />,
                        <DeviceMultiple key={1} className={styles.overlayIcon} aria-label="On your device" />,
                    ]}
                    rows={rows}
                />
            </div>
        );
    }

    return createPortal(
        <>
            <div
                className={styles.bottomSheetOverlay}
                role="presentation"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onMobileClose?.();
                }}
            />
            <div className={styles.bottomSheetContent}>
                <div className={styles.titleGroup}>
                    <Text tag="p">{mobileTitle}</Text>
                    <button onClick={onMobileClose} aria-label="close the modal">
                        <CloseIcon />
                    </button>
                </div>
                <DynamicTable
                    columnLabels={[
                        <DeviceCar key={0} className={styles.overlayIcon} aria-label="In the car" />,
                        <DeviceMultiple key={1} className={styles.overlayIcon} aria-label="On your device" />,
                    ]}
                    rows={rows}
                    isMobile={true}
                />
            </div>
        </>,
        document.body,
    );
}
